import { render, staticRenderFns } from "./wy-interactions-metrics-page.vue?vue&type=template&id=74e696dd&"
import script from "./wy-interactions-metrics-page.vue?vue&type=script&lang=js&"
export * from "./wy-interactions-metrics-page.vue?vue&type=script&lang=js&"
import style0 from "./wy-interactions-metrics-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports